import { PageShell } from "../components/layout/PageShell";
import { CtaBand } from "../components/layout/CtaBand";

const GALLERY = [
  {
    id: "meadow",
    title: "At the Meadow",
    photos: [
      { src: "spaniel-viaduct-arches.webp", alt: "Flying beneath the arches" },
      { type: "video", src: "/videos/meadow-buttercups-dogs.mp4", poster: "/videos/meadow-buttercups-dogs.jpg", alt: "The Meadow in full swing" },
      { type: "video", src: "/videos/meadow-pack-play.mp4", poster: "/videos/meadow-pack-play.jpg", alt: "The pack at play" },
      { src: "duo-running-viaduct.jpg", alt: "Two dogs running beneath Culloden Viaduct" },
      { src: "trio-sunny-viaduct.webp", alt: "Three friends in the sunshine at the Meadow" },
      { src: "pack-meadow-wide.webp", alt: "The walking crew spread across the field" },
      { src: "group-buttercup-meadow.webp", alt: "Buttercup season" },
      { src: "cockapoo-blue-harness-buttercups.webp", alt: "Taking in the view" },
      { src: "doodle-smile-buttercups.webp", alt: "A very good morning" },
      { src: "lab-yarrow-dachshunds.webp", alt: "Among the yarrow" },
      { src: "cocker-running-buttercups.webp", alt: "Full speed through the flowers" },
      { src: "white-cockapoo-viaduct-buttercups.webp", alt: "Smiles beneath the viaduct" },
      { src: "dachshund-pink-yarrow.webp", alt: "Small dog, big meadow" },
    ],
  },
  {
    id: "forest",
    title: "Forest & Trails",
    photos: [
      { src: "brown-cockapoo-trail.webp", alt: "A woodland wander" },
      { src: "cream-cockapoo-forest.webp", alt: "Forest light" },
      { src: "dachshund-forest-logs.jpg", alt: "King of the log pile" },
      { src: "rottweiler-forest-logs.jpg", alt: "Surveying the pinewoods" },
      { src: "fox-red-lab-logs.jpg", alt: "A quiet moment on the logs" },
      { src: "cockapoo-pink-bandana-logs.jpg", alt: "Autumn colours" },
      { src: "border-collie-hills.jpg", alt: "Hill path company" },
    ],
  },
  {
    id: "characters",
    title: "Little Characters",
    photos: [
      { src: "cocker-running-hills.webp", alt: "Ears up, brakes off" },
      { src: "dachshund-long-grass.webp", alt: "The thinker" },
      { src: "rottweiler-mid-stride.webp", alt: "Incoming" },
      { src: "mocha-cockapoo-pink-coat.webp", alt: "Mocha, head of quality control" },
      { src: "jingle-black-cat.webp", alt: "Jingle, who runs the household" },
      { src: "french-bulldog-portrait.jpg", alt: "The look" },
      { src: "corgi-smile-field.webp", alt: "Pure joy" },
      { src: "yellow-lab-smile.webp", alt: "Happy to be out" },
      { src: "dachshund-licking-nose.webp", alt: "Mid-thought" },
      { src: "pug-dachshund-meadow.webp", alt: "An unlikely pair" },
      { src: "two-doodles-playing.webp", alt: "Best friends" },
      { src: "grey-lurcher-daisies.webp", alt: "Among the daisies" },
      { src: "cream-cockapoo-blue-sky.jpg", alt: "Blue sky days" },
      { src: "labradoodle-meadow.webp", alt: "Tall grass explorer" },
      { src: "two-dogs-meadow-sky.webp", alt: "Side by side" },
    ],
  },
  {
    id: "about",
    title: "Out & About",
    photos: [
      { src: "van-transit-boxes.webp", alt: "The crew, safely loaded at the Meadow" },
      { type: "video", src: "/videos/carly-field-run.mp4", poster: "/videos/carly-field-run.jpg", alt: "Out with the crew" },
      { src: "spaniel-inverness-castle.jpg", alt: "A walk past Inverness Castle" },
      { src: "dog-water-leap.jpg", alt: "Making a splash" },
      { src: "retriever-stick-loch.jpg", alt: "The perfect stick" },
      { src: "carly-paddleboard-spaniel.jpg", alt: "Paddleboard passenger" },
      { src: "lab-paw-handshake-view.jpg", alt: "Paw over the city" },
      { src: "fox-red-lab-handshake.jpg", alt: "Pleased to meet you" },
      { src: "two-spaniels-bench.jpg", alt: "Bench break" },
      { src: "carly-walking-pack-forest-path.webp", alt: "Off to work" },
      { src: "carly-rottweiler-hillside.jpg", alt: "Hillside friends" },
      { src: "carly-three-dogs-autumn.jpg", alt: "Autumn crew" },
    ],
  },
];

export default function MeetTheGangPage() {
  return (
    <PageShell title="Meet the Gang">
      <section className="pt-20 pb-10 sm:pt-28 sm:pb-14" data-testid="gang-hero">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <p className="eyebrow">Meet the Gang</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[#292A26] tracking-tight mt-4 max-w-3xl" data-testid="gang-heading">
            The familiar faces of Mary Pawpins.
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#575953]">
            From the regular walking crew to the home-visit regulars and occasional
            house-sitting companions. Here's a little look at some of the personalities
            around here.
          </p>
        </div>
      </section>

      {GALLERY.map((group) => (
        <section key={group.id} className="py-8 sm:py-10" data-testid={`gang-${group.id}`}>
          <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <h2 className="font-serif text-2xl sm:text-3xl font-medium text-[#292A26] tracking-tight">{group.title}</h2>
            <div className="mt-6 columns-2 md:columns-3 lg:columns-4 gap-4">
              {group.photos.map((p) => (
                <figure key={p.src} className="break-inside-avoid mb-4">
                  {p.type === "video" ? (
                    <video
                      src={p.src}
                      poster={p.poster}
                      autoPlay muted loop playsInline
                      aria-label={p.alt}
                      className="w-full rounded-2xl"
                    />
                  ) : (
                    <img
                      src={`/images/marypawpins/${p.src}`}
                      alt={p.alt}
                      loading="lazy"
                      className="w-full rounded-2xl"
                    />
                  )}
                  <figcaption className="mt-2 text-xs text-[#575953] italic">{p.alt}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>
      ))}

      <CtaBand
        testId="gang-cta"
        heading="Could your pet be one of the gang?"
        copy="Every face here started with an enquiry and a relaxed meet & greet. Tell Carly a little about yours."
      />
    </PageShell>
  );
}
